const REGEX_USER_ID = /^user_/i

/**
 * Get recipients from to, cc or cco
 * @param {[{id?: string, value?: string, name?: string, phone?: string, email?: string}]} data
 *
 * @returns {[{id?: string, identifier?: string}]}
 */
export const getRecipients = (data = []) => {
  if (!Array.isArray(data)) return []

  return data.map(elem => {
    if (REGEX_USER_ID.test(elem.id)) {
      return { id: elem.id }
    }

    return {
      identifier: elem.value || '',
      name: elem.name || ''
    }
  })
    .filter(elem => !!(elem.id || elem.identifier))
}
